<div class="mainFrame__footer">
    <button class="log_out"
            *ngIf="isAuthorized"
            (click)="logout()">
        <span>LOG OUT</span>
    </button>
</div>
